import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid, TextField,
  Typography
} from '@material-ui/core';
import React from 'react';
import { observer } from 'mobx-react';

const MeliTab = observer(({ mainBookFormStore }) => {
  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h1">Meli</Typography>
            <FormGroup>
              <FormControlLabel control={<Checkbox
                checked={!mainBookFormStore.showMeliLinks}
                onChange={e => mainBookFormStore.setShowMeliLinks(!e.target.checked)} />}
                                label='Livro não disponível para compra' />
            </FormGroup>
          </Grid>
        </Grid>
        {mainBookFormStore.showMeliLinks && <Box>
          <br />
          <hr />
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant='h3' gutterBottom>Link para monitoria</Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField label='URL Meli'
                         onChange={(e) => mainBookFormStore.setMeliLinkData('monitoring_url', e.target.value)}
                         value={mainBookFormStore.formData.links_meli?.monitoring_url}
                         error={mainBookFormStore.errors.linksMeliFields?.monitoring_url} fullWidth />
              <br /><br /><br />
            </Grid>
            <Grid item xs={12}>
              <Typography variant='h3' gutterBottom>Livro físico</Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField label='ISBN'
                         onChange={(e) => {
                           if (e.target.value.length > 14) {
                             e.target.value = e.target.value.slice(0, 14);
                             return;
                           }
                           mainBookFormStore.setMeliLinkData('isbn', e.target.value)}
                         }
                         value={mainBookFormStore.formData.links_meli?.isbn}
                         error={mainBookFormStore.errors.linksMeliFields?.isbn} />
            </Grid>
            <Grid item xs={12}>
              <TextField label='URL Seeds'
                         onChange={(e) => mainBookFormStore.setMeliLinkData('physical_url', e.target.value)}
                         value={mainBookFormStore.formData.links_meli?.physical_url}
                         error={mainBookFormStore.errors.linksMeliFields?.physical_url} fullWidth />
              <br /><br /><br />
            </Grid>
          </Grid>
        </Box>}
      </CardContent>
    </Card>
  );
});

export default MeliTab;
